// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all-events {\n  padding: 30px 0 0 0; }\n  .all-events .content-all-events {\n    margin: 30px 0 30px 119px;\n    display: flex;\n    flex-direction: row;\n    flex-flow: row wrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 23px;\n    padding: 0; }\n    .all-events .content-all-events .events_card-component {\n      width: 281px !important; }\n", ""]);
// Exports
module.exports = exports;
